// The per-product table for the live pick'em games (QB1 = NFL per drive,
// Ball Park Power = MLB per half-inning). Everything the shared Live* components
// vary by product lives here, so a page is a thin wrapper that passes `product`.
export type LiveProductKey = 'qb1' | 'bpp'

export interface LiveProductInfo {
  key: LiveProductKey
  label: string          // display name
  short: string          // nav / crumb label (lowercase, the menu doctrine)
  league: string         // useLeagueBadge key
  unitNoun: string       // 'drive' | 'half inning'
  unitOpenedCopy: string // the toast when a new unit opens
  pickPrompt: string
  weekStartDow: number   // 4 = thursday (QB1), 1 = monday (BPP) — display only
  home: string
  tagline: string
}

const PRODUCTS: Record<LiveProductKey, LiveProductInfo> = {
  qb1: {
    key: 'qb1', label: 'QB1', short: 'qb1', league: 'nfl',
    unitNoun: 'drive', unitOpenedCopy: 'New Drive!',
    pickPrompt: 'Select an outcome for this drive',
    weekStartDow: 4, home: '/qb1',
    tagline: 'Call every drive before the snap. Pick early, hold it, and the points multiply.',
  },
  bpp: {
    key: 'bpp', label: 'Ball Park Power', short: 'bpp', league: 'mlb',
    unitNoun: 'half inning', unitOpenedCopy: 'New Half Inning!',
    pickPrompt: 'Pick the power band for this half inning',
    weekStartDow: 1, home: '/bpp',
    tagline: 'Predict how much power each half inning brings. Nail the band, or land next to it for half.',
  },
}

export function liveProductInfo(product: string): LiveProductInfo {
  return PRODUCTS[(product === 'bpp' ? 'bpp' : 'qb1') as LiveProductKey]
}

export function useLiveProduct(product: string) {
  const info = liveProductInfo(product)
  const isQb1 = info.key === 'qb1'
  const isBpp = info.key === 'bpp'
  // level-2 crumb trail: the product lobby is the parent everywhere
  const crumbs = (label: string) => [{ label: info.short, to: info.home }, { label }]
  return { info, isQb1, isBpp, crumbs }
}
